import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";
import { DefaultNav } from "../nav";
import LoaderComponent from "../components/LoaderComponent";

const AsyncHome = Loadable({
  loader: () => import("../components/Home"),
  loading: LoaderComponent
});
const AsyncAbout = Loadable({
  loader: () => import("../components/About"),
  loading: LoaderComponent,
  delay: 5000
});
const AsyncContact = Loadable({
  loader: () => import("../components/Contact"),
  loading: LoaderComponent,
  delay: 5000
});
const AsyncNotFound = Loadable({
  loader: () => import("../components/NotFound"),
  loading: LoaderComponent
});

class Routes extends Component {
  render() {
    return (
      <Router>
        <>
          <DefaultNav />
          <Switch>
            <Route exact path="/" component={AsyncHome} />
            <Route path="/about" component={AsyncAbout} />
            <Route path="/contact" component={AsyncContact} />
            <Route path="*" component={AsyncNotFound} />
          </Switch>
        </>
      </Router>
    );
  }
}

export default Routes;
